import React, { Component } from "react";

import "./Accordion.css";

class Accordion extends Component {
  state = {
    open: null,
  };
  openSlide = (index) => {
    this.setState({ open: index });
  };
  closeSlide = (index) => {
    this.setState({ open: null });
  };
  render() {
    return (
      <div className="Accordion">
        {this.props.children.map((child, index) => {
          let clickFunc = () => {
            this.openSlide(index);
          };
          let classes = "AccordionSlide";
          if (this.state.open === index) {
            clickFunc = () => {
              this.closeSlide(index);
            };
            classes += " open";
          }
          return (
            <div className={classes} key={index}>
              <h3 onClick={clickFunc}>{child.props.title}</h3>
              <div className="SlideBody">{child.props.children}</div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default Accordion;
